import React, { useState, useEffect,useRef } from 'react';
import './FAQ.css';
import Wave from '../Asset/svgviewer-png-output.png';
import icon1 from '../Asset/Vector 7.png';
import arrowBottom from '../Asset/Arrow 6.png';

const GeneralLiabilityFAQ = () => {
  const [faqs] = useState([
    {
      question: "Q1. How Do I Get General Liability Insurance?",
      answer: (
        <>
         To get general liability insurance, the process typically involves:
         <span style={{ color: "#F37435", fontWeight: "700"}}>1. Obtaining a Quote:</span><span style={{ color: "black"}}> Go on Policy Planner under “General Liability” provide some details and you can see quotes from different companies.</span>
         <span style={{ color: "#F37435", fontWeight: "700"}}>2. Comparing Policies: </span><span style={{ color: "black"}}>Review quotes from multiple insurers to find the coverage that best fits your needs at a competitive rate. Consider factors like coverage limits, deductibles, and any exclusions or additional riders.</span>
         <span style={{ color: "#F37435", fontWeight: "700"}}>3. Purchasing the Policy:</span> <span style={{ color: "black"}}>Once you’ve selected the right policy, you capurchase it . The process isusually completed within 24-48 hours, and youll receive your policydocuments and a certificate of insurance.</span>

        </>
      )
    },
    {
      question: "Q2. Do Startups Need General Liability Insurance?",
      answer: (
        <>
         Startups! <span style={{ color: "#F37435", fontWeight: "700"}}>Don't skip general liability insurance.</span> Even small businesses can face lawsuits that hurt their finances. This insurance helps by:
        Covering costs if someone gets hurt, your property damages something, or you make a marketing mistake.
       Protecting your stuff (furniture, computers) from being taken to pay for a lawsuit.
       Meeting requirements from contracts or partnerships you sign.
      Showing others you're a responsible business that takes risks seriously.
       </>
      )
    },
    {
      question: "Q3. What Is the Difference Between General Liability and fessional Liability Insurance?",
      answer:(
        <>
       The key difference between general liability and professional liability insurance is the type of claims they cover:
       <span style={{ color: "#F37435", fontWeight: "700"}}>General Liability Insurance </span>covers claims of bodily injury, property damage,
         personal injury, and advertising injury that arise from your business operationsor products.
        <span style={{ color: "#F37435", fontWeight: "700"}}>Professional Liability Insurance </span>(also known as errors and omissions
        insurance) covers claims of negligence, mistakes, or failure to perform
        professional services as expected.While general liability protects against third-party claims, professional liability
        covers claims related to your professional services or advice.
      </>
      )
      },

      {
        question: "Q4. How long does it usually take to process a claim?",
        answer:(
          <>
        Generally, claims are processed within a few days to a few weeks once all necessary information and documentation have been submitted to the insurer.
        Factors that influence the processing time include how complex the claim is, the extent of damage or loss, and the insurer's internal procedures for reviewing and approving claims.
        Providing complete and accurate information promptly can help fasten the claim processing timeline.
        </>
        )
        },
    {
      question: "Q5. How Can I Reduce My General Liability Insurance Costs?",
      answer: (
        <>
        There are several strategies you can use to help lower your general liability insurance premiums:

        <ul style={{ listStyleType: "disc", marginLeft: "20px" }}>
        <li><span style={{ color: "#F37435", fontWeight: "700" }}>Increase Your Deductible:</span> <span style={{ color: "black" }}>Opting for a higher deductible can significantly reduce your monthly or annual premium costs.</span></li>
         <li><span style={{ color: "#F37435", fontWeight: "700" }}>Bundle Policies:</span> <span style={{ color: "black" }}>Combining your general liability insurance with other business policies, such as property or professional liability, may qualify you for discounts.</span></li>
        <li><span style={{ color: "#F37435", fontWeight: "700" }}>Improve Safety Practices:</span> <span style={{ color: "black" }}>Implementing safety measures and risk management protocols can demonstrate to insurers that your business has a lower risk profile.</span></li>
        <li><span style={{ color: "#F37435", fontWeight: "700" }}>Maintain a Clean Claims History:</span> <span style={{ color: "black" }}>Avoiding frequent or large liability claims can help you qualify for better rates over time.</span></li>
        <li><span style={{ color: "#F37435", fontWeight: "700" }}>Shop Around:</span> <span style={{ color: "black" }}>Comparing quotes from multiple insurers can help you find the most competitive pricing for the coverage you need.</span></li>
       </ul>
        </>
      )
      
    
    },
    {
      question: "Q6. Does general liabilty cover damages to my property?",
      answer: (
        <>
         <span style={{ color: "#F37435", fontWeight: "700"}}>No, </span>general liability insurance typically does not cover damages to your own property.
         General liability (GL) insurance focuses on protecting your business from third-party claims. This means it covers situations where someone else gets hurt, their property gets damaged, or they suffer a financial loss due to your business activities.
        </>
      )
      
    },
   
  ]);

  const [visible, setVisible] = useState(false);
  const [buttonClicked, setButtonClicked] = useState(false);
  const [selectedFaqIndex, setSelectedFaqIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  const faqContainerRef = useRef(null);

 const toggleVisibility = () => {
    if (window.pageYOffset > 100 && !buttonClicked) {
      setVisible(true);
    } else if (window.pageYOffset <= 100) {
      setVisible(false);
      setButtonClicked(false); // Allow the button to reappear once the user scrolls back to the top
    }
  };

  const scrollToTop = (e) => {
    e.preventDefault(); // Prevent the default anchor click behavior
    console.log(visible); // Log current state
    setVisible(false); // Hide the button immediately when clicked
    setButtonClicked(true); // Mark the button as clicked
  };

  useEffect(() => {
    if (!visible && buttonClicked) {
      console.log(visible); // Log updated state
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  }, [visible, buttonClicked]);

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, [buttonClicked]);



  
  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

//   const handleFaqClick = (index) => {
//     setSelectedFaqIndex(selectedFaqIndex === index ? null : index);
//   };
const handleFaqClick = (index) => {
    if (isMobile) {
      setSelectedFaqIndex(selectedFaqIndex === index ? null : index);
    } else {
      setSelectedFaqIndex(index);
    }
  };
  const handleClickOutside = (event) => {
    if (faqContainerRef.current && !faqContainerRef.current.contains(event.target)) {
      setSelectedFaqIndex(null);
    }
  };

  useEffect(() => {
    if (isMobile) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMobile]);

  return (
    <div>
      <div className='qa-section'>
        <img src={Wave} alt="Wave" className='waveimg' />
        <div ref={faqContainerRef} className={`faq-ct ${isMobile ? 'mobile' : ''}`}>
          <div className="ct box">
            <div className="ct2">
              <h2 style={{ color: "#F37435", fontWeight: "700" }}>FAQ</h2>
              <p style={{ fontSize: "20px", fontWeight: "400", marginTop: '2rem' }}>Frequently Asked Questions</p>
            </div>
            <div className="subct">
              <ul style={{ listStyleType: "none", padding: 0 }}>
                {faqs.map((faq, index) => (
                  <li
                    className={`ct3 ${selectedFaqIndex === index ? "highlighted" : ""} ${isMobile ? "highlighted" : ""}`}
                    key={index}
                    onClick={() => handleFaqClick(index)}
                  >
                    <div className='faq-question'>
                      <strong className='view'>{faq.question}</strong>
                      <img src={icon1} className="side-arrow" alt="sideicon" />
                    </div>
                    {isMobile && (
                      <span className={`arrow ${selectedFaqIndex === index ? "expanded" : ""}`}></span>
                    )}
                    {isMobile && selectedFaqIndex === index && (
                      <div className="subcon1 mobile-subcon">
                        <p>{faq.answer}</p>
                      </div>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </div>
          {!isMobile && selectedFaqIndex !== null && (
            <div className="con">
              <div className="subcon">
                <p>{faqs[selectedFaqIndex].question}</p>
              </div>
              <div className="subcon1">
                <p>{faqs[selectedFaqIndex].answer}</p>
              </div>
            </div>
          )}
        </div>
        {visible && (
          <a
            href="#"
            id="scroll"
            onClick={scrollToTop}
            // style={styles.scroll}
            
          >
            <img src={arrowBottom} id="arrowsign" alt="Scroll to top"  />
          </a>
        )}
      </div>
    </div>
  );
};

const styles = {
  scroll2: {
    position: 'fixed',
    display: 'flex',
    alignItems: 'center',
    right: '5%',
    bottom: '10rem',
    // right: '2%',
    // bottom: '1rem',
    cursor: 'pointer',
    width: '71px',
    height: '71px',
    backgroundColor: 'white',
    borderRadius: '60px',
    zIndex: '1000',
    justifyContent: 'center',
    // boxShadow: '0px 10px 26px rgba(0, 109, 141, 0.2)', 
    boxShadow: '0px 1px 16px rgba(0, 109, 141, 0.25)',
  },
 

  
 span: {
    display: 'block'
  }

};



export default GeneralLiabilityFAQ;